import { Inject, Injectable } from '@angular/core';
import { RootContext } from '@skylab-angular-shared/core';
import { BankAccountCollectionQuery, BannerInfoQuery, ClientGroupCollectionQuery, CommunityTransactionForPurchaseQuery, CommunityTransactionForSaleQuery, CompanyConfigUrlsQuery, CompanyFeaturesQuery, CompanyParametersQuery, ContextKeys, CountryCollectionQuery, CurrencyCollectionQuery, ExpensePagedCollectionQuery, InventoryKindQuery, KsefSendParametersQuery, LaboratoryInfoQuery, LoggedUserQuery, MarginSchemeKindQuery, OnlineReceiversQuery, PaymentMethodBaseQuery, PaymentMethodQuery, ProductGroupCollectionQuery, ProductJpkVatGroupCollectionQuery, PurchaseKindQuery, SaleJpkVatGroupCollectionQuery, SaleKindQuery, UnitQuery, UserCollectionQuery, UserLicensesQuery, UserRoleQuery, VatRateForPurchaseQuery, VatRateForSaleBaseQuery, VatRateForSaleQuery, VatRateForSaleWstoQuery, VatReleaseReasonQuery } from '@skylab-shared/business';
import { RootContextBase } from '@skylab-shared/core';
import { CompanyRepository, CompanyRepositoryBase } from './company/company.repo';

@Injectable({providedIn: 'root'})
export class RootContextConfig {
    public constructor(
        @Inject(RootContext) private readonly rootContext: RootContextBase,
        @Inject(CompanyRepository) private readonly companyRepository: CompanyRepositoryBase
    ) {}

    public async registerAsync(): Promise<void> {
        await Promise.all([
            this.rootContext.registerGloballyAsync(BankAccountCollectionQuery),
            this.rootContext.registerGloballyAsync(ClientGroupCollectionQuery),
            this.rootContext.registerGloballyAsync(CommunityTransactionForPurchaseQuery),
            this.rootContext.registerGloballyAsync(CommunityTransactionForSaleQuery),
            this.rootContext.registerGloballyAsync(CompanyParametersQuery),
            this.rootContext.registerGloballyAsync(CompanyFeaturesQuery),
            this.rootContext.registerGloballyAsync(CountryCollectionQuery),
            this.rootContext.registerGloballyAsync(CurrencyCollectionQuery),
            this.rootContext.registerGloballyAsync(ExpensePagedCollectionQuery),
            this.rootContext.registerGloballyAsync(LoggedUserQuery),
            this.rootContext.registerGloballyAsync(UserRoleQuery),
            this.rootContext.registerGloballyAsync(MarginSchemeKindQuery),
            this.rootContext.registerGloballyAsync(PurchaseKindQuery),
            this.rootContext.registerGloballyAsync(ProductGroupCollectionQuery),
            this.rootContext.registerGloballyAsync(PaymentMethodBaseQuery),
            this.rootContext.registerGloballyAsync(PaymentMethodQuery),
            this.rootContext.registerGloballyAsync(SaleKindQuery),
            this.rootContext.registerGloballyAsync(InventoryKindQuery),
            this.rootContext.registerGloballyAsync(SaleJpkVatGroupCollectionQuery),
            this.rootContext.registerGloballyAsync(UnitQuery),
            this.rootContext.registerGloballyAsync(UserCollectionQuery),
            this.rootContext.registerGloballyAsync(UserLicensesQuery),
            this.rootContext.registerGloballyAsync(VatRateForSaleQuery),
            this.rootContext.registerGloballyAsync(VatRateForSaleBaseQuery),
            this.rootContext.registerGloballyAsync(VatRateForSaleWstoQuery),
            this.rootContext.registerGloballyAsync(VatRateForPurchaseQuery),
            this.rootContext.registerGloballyAsync(VatReleaseReasonQuery),
            this.rootContext.registerGloballyAsync(OnlineReceiversQuery),
            this.rootContext.registerGloballyAsync(ProductJpkVatGroupCollectionQuery),
            this.rootContext.registerGloballyAsync(LaboratoryInfoQuery),
            this.rootContext.registerGloballyAsync(BannerInfoQuery),
            this.rootContext.registerGloballyAsync(KsefSendParametersQuery),

            this.rootContext.registerGloballyAsync(ContextKeys.company, () => this.companyRepository.findAsync()),
            this.rootContext.registerGloballyAsync(ContextKeys.systemCurrency, () => {
                return this.rootContext.getAsync(CompanyParametersQuery)
                    .then(params => params.systemCurrency)
                    .then(systemCurrencySymbol => this.rootContext.firstAsync(CurrencyCollectionQuery, { symbol: systemCurrencySymbol }));
            })
        ]);

        this.rootContext.registerGloballyAsync(CompanyConfigUrlsQuery, { repeat: true });
    }
}
